import LOGO from "../assets/images/LOGO.png";
import AVATAR from "../assets/images/bot.svg";
import OPERATOR_IMAGE from "../assets/images/operator.svg";
import ALGORITMLOGO from "../assets/images/algoritm-logo.svg";
import BSILOGO from "../assets/images/bsi-logo.svg";

const { isSaderatCustomization } = JSON.parse(sessionStorage.getItem("config"));

const tosanBlue = "rgba(0, 74, 143, 1)";
const tosanYellow = "rgba(255, 192, 0, 1)";
const white = "rgba(255, 255, 255, 1)";
const tosanBlue70 = "rgba(0, 74, 143, 0.7)";
const tosanYellow50 = "rgba(255, 191, 0, 0.55)";
const saderatBlue = "rgba(0, 206, 255, 1)";
const saderatLightBlue = "rgba(0, 206, 255, 0.2)";
const black = "black";
const darkText = "#3A3F49";
const lightGray = "#e6e6e6";
const mediumGray = "#999999";
const darkGray = "#61656D";
const red = "rgb(217, 100, 89)";
const green = "rgb(76, 172, 59)";
const shadowGray = "rgba(0 ,0 ,0 ,0.15)";

export const theme2 = {
  headerBg: white,
  headerDotsBg: white,
  headerDotColor: darkText,
  roomButtonBg: "#4E535C",
  roomButtonBgSaderat: saderatBlue,
  questionBubbleBg: "#0054FF",
  questionBubbleColor: white,
  answerBubbleBg: white,
  answerBubbleBgSaderat: saderatLightBlue,
  answerBubbleColor: darkText,
  answerBtnBg: "#FFECD1",
  answerBtnBgHover: "rgba(255, 192, 103, 0.8)",
  answerBtnColor: darkText,
  helpButtonBg: tosanBlue70,
  helpButtonBgHover: tosanBlue,
  helpButtonColor: white,
  endLivechatBtnBg: red,
  endLivechatBtnBgHover: red,
  endLivechatBtnColor: white,
  acceptVoiceColor: green,
  cancelVoiceColor: red,
  errormessageColor: red,
  authenticationBtnBg: tosanBlue,
  authenticationBtnColor: white,
  recordBtnColor: darkGray,
  recordBtnBg: "#0054FF",
  footerBg: white,
  // footerBg: "#F4F6F8",
  invalidFooterInputColor: red,
  sendMessageBtnColor: white,
  authenticationResendColor: tosanYellow,
  moreBtnBg: mediumGray,
  automessageColor1: "rgba(66, 143, 255, 1)",
  automessageColor2: "rgba(225, 126, 39, 1)",
  chatTimeColor: darkGray,
  authenticationLinkTextColor: mediumGray,
  authenticationLinkTextColor2: white,
  loginBgColor1: tosanYellow50,
  loginBgColor2: tosanBlue,
  wrapLoginBg: white,
  authInputColor: darkGray,
  authInputSymbolColor: darkGray,
  authInputBg1: lightGray,
  authInputBg2: white,
  bubbleShadowColor: shadowGray,
  botImageShadowColor: shadowGray,
  authTitleColor: black,
  messageFontSize:
    window.localStorage.getItem("fontSize") ??
    JSON.parse(sessionStorage.getItem("config")).defaultFont,
  logoImage: isSaderatCustomization ? ALGORITMLOGO : LOGO,
  bsiLogo: BSILOGO,
  avatarImage: AVATAR,
  operatorImage: OPERATOR_IMAGE,
  dateColor: darkGray,
  jumpBtnBg: "rgba(172, 177, 187, 0.4)",
  jumpBtnColor: white,
  powerByColor: mediumGray,
  usermodalHeaderBg: mediumGray,
  usermodalHeaderColor: black,
  invalidTokenBg: tosanYellow,
  invalidTokenContainerBg: tosanBlue,
  avatarBg: tosanBlue70,
};
